import {Observable} from 'protoc-gen-ts';

type WithObservable<T> = {
  items: T[];
  stream: Observable<T>;
  trailers: string[];
};

export const hasUnresolvedStream = <T>(
  data?: T | Record<string, unknown>,
): data is WithObservable<T> => {
  return Boolean(
    data &&
      'stream' in (data as Record<string, unknown>) &&
      (data as Record<string, any>).stream.subscribe,
  );
};

export const isEmptyStream = <T>(
  data?: T | Record<string, unknown>,
): data is WithObservable<T> => {
  return (
    hasUnresolvedStream(data) &&
    Boolean('items' in data) &&
    data.items.length === 0
  );
};

export const resolveStreamToPromise = async (data: unknown) => {
  const resolvedData = await new Promise((resolve, reject) => {
    if (hasUnresolvedStream(data)) {
      const responseData: {items: unknown[]; trailers: string[]} = {
        items: [],
        trailers: [],
      };

      data.stream.subscribe({
        next: item => responseData.items.push(item),
        error: reject,
        complete: () => {
          responseData.trailers = data.trailers;
          return resolve(responseData);
        },
      });
    } else {
      resolve(data);
    }
  });

  return resolvedData;
};
